// extracted by mini-css-extract-plugin
export var brandLockup = "_dg-5";
export var brandLogo = "_dg-6";
export var bullet = "_dg-1i";
export var bulletText = "_dg-1h";
export var bullets = "_dg-1c";
export var callout = "_dg-12";
export var calloutBody = "_dg-14";
export var calloutLabel = "_dg-13";
export var checkIcon = "_dg-1e";
export var checkList = "_dg-1b";
export var checkSvg = "_dg-1f";
export var checkText = "_dg-1g";
export var choiceCard = "_dg-x";
export var choiceDescription = "_dg-10";
export var choiceIcon = "_dg-11";
export var choiceText = "_dg-y";
export var choiceTitle = "_dg-z";
export var closeButton = "_dg-d";
export var codeText = "_dg-28";
export var compactPage = "_dg-f";
export var content = "_dg-9";
export var contentColumn = "_dg-3";
export var coverageCard = "_dg-o";
export var coverageDescription = "_dg-24";
export var coverageTitle = "_dg-23";
export var eyebrow = "_dg-i";
export var fieldCard = "_dg-m";
export var fieldDescription = "_dg-r";
export var fieldError = "_dg-s";
export var fieldHeader = "_dg-p";
export var fieldTitle = "_dg-q";
export var finalNote = "_dg-29";
export var footer = "_dg-a";
export var fulfillmentBody = "_dg-1u";
export var fulfillmentBodyText = "_dg-1v";
export var fulfillmentRow = "_dg-1r";
export var fulfillmentRows = "_dg-1q";
export var fulfillmentTitle = "_dg-1t";
export var header = "_dg-4";
export var heading = "_dg-h";
export var helperText = "_dg-1k";
export var indented = "_dg-1x";
export var inlineLink = "_dg-26";
export var inlineTitle = "_dg-2a";
export var intro = "_dg-k";
export var linkPreview = "_dg-1z";
export var listItem = "_dg-1d";
export var main = "_dg-1";
export var marketingImage = "_dg-c";
export var marketingPanel = "_dg-b";
export var modal = "_dg-0";
export var noteBody = "_dg-v";
export var noteBodyText = "_dg-w";
export var noteCard = "_dg-n";
export var noteIcon = "_dg-t";
export var noteTitle = "_dg-u";
export var numberBadge = "_dg-2e";
export var numberedStep = "_dg-2c";
export var numberedStepBody = "_dg-2f";
export var numberedStepCta = "_dg-2d";
export var numberedStepDescription = "_dg-2h";
export var numberedStepTitle = "_dg-2g";
export var numberedSteps = "_dg-2b";
export var page = "_dg-e";
export var playCircle = "_dg-18";
export var playIcon = "_dg-19";
export var policyBody = "_dg-21";
export var policyHeader = "_dg-20";
export var policyPreview = "_dg-1y";
export var policyTitle = "_dg-22";
export var progressFill = "_dg-8";
export var progressTrack = "_dg-7";
export var pseudoLink = "_dg-25";
export var pseudoLinkIcon = "_dg-27";
export var rowHeader = "_dg-1s";
export var section = "_dg-g";
export var shell = "_dg-2";
export var statusIconSuccess = "_dg-1m";
export var statusIconSvg = "_dg-1o";
export var statusIconWarning = "_dg-1n";
export var statusRow = "_dg-1l";
export var statusText = "_dg-1p";
export var stepTitle = "_dg-j";
export var strongText = "_dg-1w";
export var subHeading = "_dg-l";
export var videoEmbed = "_dg-16";
export var videoIframe = "_dg-17";
export var videoLabel = "_dg-1a";
export var videoPlaceholder = "_dg-15";
export var warningIcon = "_dg-1j";